/* eslint-ignore */
// @ts-nocheck
import React from "react";

import { Container, TolltipItens, TooltipContainer } from "./styles";

const OldPasswordMobile: React.FC = () => {
  return (
    <Container>
      <TooltipContainer>
        <TolltipItens>
          <span>
            {`Caso não lembre sua senha atual, ao clicar no link você será deslogado e direcionado para a seção "Esqueci minha senha"`}
          </span>
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default OldPasswordMobile;
